var _this = this;
import * as tslib_1 from "tslib";
import { loadFullBody } from '../actions/loadFullBody';
import { updateCachedItemBodies, updateIsLoadingFullBody } from '../mutators/loadFullBodyMutators';
import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import mailStore from 'owa-mail-store/lib/store/Store';
import { getBaseItemResponseShape } from 'owa-mail-store/lib/utils/getItemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { orchestrator } from 'satcheljs';
export default orchestrator(loadFullBody, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var viewState, itemId, item, itemShape, shapeName, response, responseItem;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                viewState = actionMessage.viewState;
                itemId = viewState.itemId;
                updateIsLoadingFullBody(viewState, true);
                item = mailStore.items.get(itemId);
                itemShape = getBaseItemResponseShape();
                shapeName = 'ItemPart';
                if (!item.UniqueBody) {
                    // If we don't have a UniqueBody, change the shapeName to get the NormalizedBody instead.
                    shapeName = 'ItemNormalizedBody';
                }
                else if (item.NormalizedBody) {
                    // If we have both, request NormalizedBody as an additionalProperty.
                    itemShape.AdditionalProperties.push(propertyUri({ FieldURI: 'NormalizedBody' }));
                }
                itemShape.MaximumBodySize = 0;
                return [4 /*yield*/, getItem([itemId], itemShape, shapeName)];
            case 1:
                response = _a.sent();
                if (mailStore.items.get(itemId) && checkIfResponseSuccess(response[0])) {
                    responseItem = response[0];
                    updateCachedItemBodies(item, responseItem.Items[0]);
                    updateIsLoadingFullBody(viewState, false);
                }
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=loadFullBodyOrchestrator.js.map